import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useResourceRequestList } from "../../Hooks/Features/HelpDesk/useResourceRequestList";
import DatePicker from "react-multi-date-picker";
import { SkeletonDataTable } from "../Loader/Loader";
import { AgGridReact } from "@ag-grid-community/react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import ResourceRequest from "./ResourceRequest";
import { useTheme } from "../../context/ThemeContext";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";

const ResourceRequestList = () => {

    const { dropDownOption, handleStatusChange, filterValues, setFilterValues, getResourceRequestList, loader, rowData, coldef, showRequestPopup, setShowRequestPopup, showAssignPopup, setShowAssignPopup, handleAssign, assignData, setAssignData } = useResourceRequestList();
    const { theme } = useTheme();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);
    
    return (
        <div>
            <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3 px-3">
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                    <h5 className="mb-0">Resource Request</h5>
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2">
                    <button className="sk-btn sk-btn-primary" onClick={() => getResourceRequestList()} title="Refresh">
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                    <button className="sk-btn sk-btn-primary bg-black text-white" onClick={() => setShowRequestPopup(true)} title="Create Request">
                        <FontAwesomeIcon icon="fa-solid fa-plus" /> Create Request
                    </button>
                </div>
            </div>

            {loader?.grid ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 110px)" }}>
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={coldef}
                        rowHeight={30}
                    />
                </div>
            }
            <Dialog visible={showRequestPopup} onHide={() => setShowRequestPopup(false)} draggable={false} className="modal-large" header="Create Resource Request">
                <ResourceRequest dropDownOption={dropDownOption} onClose={() => { setShowRequestPopup(false); getResourceRequestList() }} />
            </Dialog>

            <Dialog visible={showAssignPopup} onHide={() => setShowAssignPopup(false)} draggable={false} className="modal-xsmall" header="Assign Resource">
                <div className="d-flex gap-2">
                    <div className="w80">
                        <Dropdown placeholder="Select a User" className="sk-input-dd" value={assignData?.selected_user || null} onChange={(e) => setAssignData((prev) => ({ ...prev, selected_user: e.target.value }))} options={dropDownOption?.filteredUsers} optionLabel="user_display_name" filter filterInputAutoFocus />
                    </div>
                    <div className="text-right w20">
                        {loader?.btn ?
                            <button className="sk-btn sk-btn-primary w100">
                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> :
                            <button className="sk-btn sk-btn-primary w100" onClick={() => handleAssign()}>Assign</button>
                        }
                    </div>
                </div>
            </Dialog>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValues((prev) => ({
                                    ...prev,
                                    hoveredRange: [],
                                    projects: [],
                                    all_users: [],
                                    technology: [],
                                    status: dropDownOption?.statusOptions?.[0],
                                    isChange: true
                                }));
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Date Picker Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Date Range</div>
                                <DatePicker
                                    ref={datePickerRef}
                                    value={filterValues?.hoveredRange}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true }));
                                        if (e && e.length === 2) {
                                            datePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    range
                                    rangeHover
                                    style={{ width: "100%" }}
                                    containerStyle={{ width: "100%" }}
                                    inputClass="w-100 sk-input-dd"
                                    placeholder="Select Date"
                                />
                            </div>

                            {/* CommonFilterDropdown */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Dimensions</div>
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 12 },
                                        { key: "all_users", label: "Users", col: 12 },
                                        { key: "technology", label: "Technology", col: 12 }
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues}
                                />
                            </div>

                            {/* Status Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Status</div>
                                <div className='sk-segment-control mb-3'>
                                    {dropDownOption?.statusOptions?.map((item) => (
                                        <button
                                            key={item?.request_status_id}
                                            type="button"
                                            className={`sk-segment-btn ${filterValues.status?.request_status_id === item?.request_status_id ? 'active' : ''}`}
                                            onClick={() => handleStatusChange({ target: { value: item?.request_status_id } })}
                                        >
                                            {item?.request_status_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getResourceRequestList();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResourceRequestList;
